module.exports = __webpack_public_path__ + "static/img/alarm1.1dc09f87.png";